import { StylesConfig } from "react-select";
import makeStyles from "@material-ui/core/styles/makeStyles";

import { STYLE_TOKENS } from "../style-tokens";
import theme from "styles/theme";

export const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
    },
    label: {
        color: STYLE_TOKENS.COLORS.colRaven,
        fontFamily: theme.fontFamily,
        fontWeight: 400,
        fontSize: "14px",
        marginBottom: "5px",
    },
    asterix: {
        color: STYLE_TOKENS.COLORS.colToryRed,
        fontFamily: theme.fontFamily,
        fontWeight: 400,
        fontSize: "14px",
    },
    error: {
        display: "flex",
        alignItems: "center",
        color: STYLE_TOKENS.COLORS.colToryRed,
        fontFamily: theme.fontFamily,
        fontWeight: 400,
        fontSize: "14px",
        marginTop: "5px",
    },
    errorIcon: {
        color: STYLE_TOKENS.COLORS.colToryRed,
        marginRight: "5px",
    },
});

export const selectCustomStyles: StylesConfig = ({ hasError = false }) => ({
    container: (styles) => ({
        ...styles,
        fontSize: "14px",
        fontFamily: theme.fontFamily,
        fontWeight: 400,
        color: STYLE_TOKENS.COLORS.colRaven,
        minWidth: "100%",
    }),
    control: (styles, { isFocused }) => ({
        ...styles,
        color: hasError ? STYLE_TOKENS.COLORS.colStrawberryRose : "inherit",
        backgroundColor: hasError ? STYLE_TOKENS.COLORS.colIvoryTower : styles.backgroundColor,
        borderColor: hasError ? STYLE_TOKENS.COLORS.colStrawberryRose : theme.palette.grey,
        borderRadius: "4px",
        height: "40px",
        boxShadow: hasError && isFocused ? `0 0 0 1px  ${STYLE_TOKENS.COLORS.colStrawberryRose}` : styles.boxShadow,

        ":hover": {
            ...styles[":hover"],
            borderColor: hasError ? STYLE_TOKENS.COLORS.colStrawberryRose : theme.palette.grey,
        },
    }),
    input: (styles) => ({
        ...styles,
        color: hasError ? STYLE_TOKENS.COLORS.colStrawberryRose : "inherit",
    }),
    singleValue: (styles: any) => ({
        ...styles,
        color: hasError ? STYLE_TOKENS.COLORS.colStrawberryRose : "inherit",
    }),
    placeholder: (styles) => ({
        ...styles,
        color: theme.palette.grey,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => ({
        ...styles,
        backgroundColor: isSelected || isFocused ? STYLE_TOKENS.COLORS.colIvoryTower : undefined,
        color: STYLE_TOKENS.COLORS.colIron,
        cursor: isDisabled ? "not-allowed" : "default",

        ":active": {
            ...styles[":active"],
            backgroundColor: !isDisabled ? STYLE_TOKENS.COLORS.colIvoryTower : undefined,
        },
    }),
    clearIndicator: (styles) => ({
        ...styles,
        cursor: "pointer",
    }),
});
